import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatHubAllowances',
})
export class FormatHubAllowancesPipe implements PipeTransform {
  private displayNamesMap: Record<string, string> = {
    hub_direct_access: 'Hub Management direct access',
    hub_allowance_app_agent_management: 'App agent management',
    hub_allowance_app_authentication: 'App authentication',
    hub_allowance_app_subagency_management: 'App subagency management',
    hub_allowance_corporate_portal_authentication: 'Corporate portal authentication',
    hub_allowance_corporate_portal_corporate_management: 'Corporate portal corporate management',
  };

  transform(obj: { [key: string]: any }): string[] {
    if (!obj) return [];

    return Object.keys(obj)
      .filter(key => obj[key] && this.displayNamesMap[key])
      .map(key => this.displayNamesMap[key]);
  }
}
